<template>
  <v-snackbar
    :value="show"
    :color="color"
    :timeout="timeout"
    @input="close">
    {{ message }}
    <v-btn
      color="white"
      flat
      @click.native="close">{{ $t('Close') }}</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  computed: {
    color: function () {
      return this.$store.getters.snackbar.color
    },
    message: function () {
      return this.$store.getters.snackbar.message
    },
    show: function () {
      return this.$store.getters.snackbar.show
    },
    timeout: function () {
      return this.$store.getters.snackbar.timeout
    }
  },
  methods: {
    close: function () {
      this.$store.dispatch('showSnackbar', { show: false })
    }
  }
}
</script>
